package com.eladfinish.bible.contest.screens.search.usecases.specialSearch

import com.eladfinish.bible.contest.common.usecases.RemoveTeamimUseCase
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.extensions.splitByRegex
import com.eladfinish.bible.contest.screens.search.model.ChapterDetails
import com.eladfinish.bible.contest.utils.gematriaWord
import io.github.aakira.napier.Napier
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

/**
 * Developed by
 * @author Elad Finish
 */

/**
 * expected output:
 * מספר המילים שערכן הגימטרי הוא
 */

data class GematriaWord(val number: Int, val word: String)

class GematriaCalculator(
    private val includeLog: Boolean = true,
) : SpecialSearch,
    KoinComponent {

    private val sb = StringBuilder()

    private val numberMap = mutableMapOf<Int, Int>()
    private val wordMap = HashMap<Int, Set<String>>()

    private var min: GematriaWord = GematriaWord(number = Int.MAX_VALUE, word = "")
    private var max: GematriaWord = GematriaWord(number = 0, word = "")

    private val removeTeamimUseCase by inject<RemoveTeamimUseCase>()

    override fun process(chapterDetails: ChapterDetails) = with(chapterDetails) {
        verses.forEach { verse ->
            verse.trim().splitByRegex(StringConstants.REGEX_SPACE).let {
                it.forEachIndexed { index, word ->
                    val key = word.gematriaWord()
//                    Napier.d("word_ $word = $key")
                    if (key == 0 || word.length == 2) {
                        Napier.d("word_ $word = $key $bookName, $chapterName, ${index.plus(1)} - $verse")
                    }
                    numberMap[key] = numberMap[key]?.plus(1) ?: 1
                    wordMap[key] = (wordMap[key] ?: emptySet()).plus(removeTeamimUseCase(word))

                    if (key < min.number) {
                        min = GematriaWord(number = key, word = word)
                    }
                    if (key > max.number) {
                        max = GematriaWord(number = key, word = word)
                    }
                }
            }
        }
    }

    override fun getSummary(): String {
        return sb.apply {
            append("הערך הכי נמוך: ").append(min.number).append(" [${min.word}]").append("\n")
            append("הערך הכי גבוה: ").append(max.number).append(" [${max.word}]").append("\n")

            if (includeLog) {
                (min.number..max.number).forEach {
                    val number = numberMap[it]
//                    Napier.d("$it -> %s", if (number == 0) "------------" else "$number words")
//                    Napier.d("$it -> %s, (distinct) %s %s",
//                            if (number == 0) "------------" else number, wordMap[it]?.size ?: 0, wordMap[it])
                    Napier.d(
                        "$it -> ${if (number == 0) "------------" else number}, (distinct) ${wordMap[it]?.size ?: 0}",
                    )
                }

                append("\n@@@\n")
            }

            append("סיכום - ערך גימטרי X:\nמספר המילים עם ערך זה").append("\n")

            numberMap
                .toList()
                .sortedBy { it.first }
                .forEach { (key, value) ->
                    append("• [$key] - $value ").append("מילים")
//                        .append(": ").append(wordMap[key])
                        .append("\n")
                }
        }.toString()
    }
}
